'use client';

import React from 'react';
import { NavBar as UINavbar, useNavbarHidden } from '@stereoagency/ui';
import { menu } from '@stereoagency/sanity-schema';
import {
  Languages,
  PageTypePrefixes,
  defaultLanguage
} from '@stereoagency/constants';
import { createDocumentURL, menuItemAsLink } from '@/utils';
import useUrl from '@/hooks/useUrl.client';

const menuQuery = menu.schema.builder.first().use();

type Props = {
  lang: string;
  primaryMenu: (typeof menuQuery)[1] | null;
  secondaryMenu: (typeof menuQuery)[1] | null;
  actionsMenu: (typeof menuQuery)[1] | null;
};

export default function Navbar({
  lang,
  primaryMenu,
  secondaryMenu,
  actionsMenu
}: Props) {
  const url = useUrl();
  const navbarHidden = useNavbarHidden();

  return (
    <UINavbar
      key={url?.toString()}
      hidden={navbarHidden}
      homepageAction={{ href: createDocumentURL(lang, 'page', null) }}
      searchAction={{
        href: createDocumentURL(lang, 'page', PageTypePrefixes[lang].search)
      }}
      action={
        actionsMenu?.menuItems?.length
          ? menuItemAsLink(actionsMenu.menuItems[0])
          : undefined
      }
      metaItems={
        secondaryMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
      legalItems={
        secondaryMenu?.menuItems?.map((item) => menuItemAsLink(item)) ?? []
      }
      items={
        primaryMenu?.menuItems?.map((item) => ({
          action: menuItemAsLink(item),
          submenu: item.submenuItems?.map((subitem) => menuItemAsLink(subitem))
        })) ?? []
      }
      languageOptions={{
        active: {
          label: lang.toUpperCase(),
          href: url ?? `/${lang}`,
          locale: lang
        },
        options: Languages.map((entry) => {
          const langUrl = url ? new URL(url) : null;
          if (langUrl) {
            if (lang === defaultLanguage.id) {
              langUrl.pathname = `/${entry.id}${langUrl.pathname}`;
            } else {
              langUrl.pathname = langUrl.pathname.replace(
                `/${lang}`,
                `/${entry.id}`
              );
            }
          }

          return {
            label: entry.id.toUpperCase(),
            href: langUrl?.toString() ?? `/${entry.id}`,
            locale: entry.id
          };
        })
      }}
    />
  );
}
